import * as featureFlagSelectors from "@rentiohq/shared-frontend/dist/redux/featureFlag/featureFlag.selectors";
import { useSelector } from "react-redux";
export var useFeatureFlag = function (flagKey, defaultValue) {
    var enabled = useSelector(function (state) { return featureFlagSelectors.getFlag(state, flagKey, defaultValue); });
    return enabled;
};
